export interface IFtpEnable {
    'module-FTP':boolean
}

export const getDefaultFtpEnable = ():IFtpEnable => {
    return {        
        'module-FTP':false
    }
} 